import { Box, Button, Paper, Typography } from "@mui/material";
import strings from "global/constants/StringConstants";
import viewpaths from "global/constants/ViewPathConstants";
import history from "utils/history";
import { SearchGlyph } from "screens/ContractSearch/components/ContractSearchIcons";
import PromptChip from "screens/ContractSearch/components/PromptChip";
import contractSearchStyles from "screens/ContractSearch/ContractSearch.styles";
import { dashFont, dashRef, dashSize } from "./DashboardReferenceStyles";

/**
 * "Jump back into Contract Search" — the dashboard's door to the repository.
 * A starter chip opens the search screen and sends that question straight
 * away (via router state); "New search" opens it empty.
 */
const DashboardContractSearchCard = () => {
  const copy = strings.contractSearch;

  const open = (ask?: string) =>
    history.push({
      pathname: viewpaths.contractSearchViewPath,
      state: ask ? { ask } : {},
    });

  return (
    <Paper
      elevation={0}
      component="section"
      aria-labelledby="dashboard-contract-search-title"
      sx={{
        borderRadius: "16px",
        border: `1px solid ${dashRef.cardBorder}`,
        boxShadow: "none",
        bgcolor: "background.paper",
        p: dashSize.sectionCardPadding,
        ...contractSearchStyles.dashboardCard,
      }}
    >
      <Box sx={contractSearchStyles.dashboardHead}>
        <Box sx={contractSearchStyles.dashboardTitleRow}>
          <Box sx={contractSearchStyles.dashboardIconTile} aria-hidden="true">
            <SearchGlyph sx={{ width: 18, height: 18 }} />
          </Box>
          <Box sx={{ minWidth: 0 }}>
            <Typography
              id="dashboard-contract-search-title"
              component="h2"
              sx={{
                fontSize: dashFont.cardHeading,
                fontWeight: 800,
                color: dashRef.heading,
              }}
            >
              {copy.dashboardTitle}
            </Typography>
            <Typography
              sx={{
                fontSize: dashFont.cardDescription,
                color: dashRef.metaText,
                mt: "2px",
              }}
            >
              {copy.dashboardBody}
            </Typography>
          </Box>
        </Box>
        <Button variant="contained" size="small" onClick={() => open()}>
          {copy.newSearch}
        </Button>
      </Box>
      <Box sx={contractSearchStyles.dashboardChips} role="group" aria-label="Suggested questions">
        {copy.starterPrompts.map((prompt) => (
          <PromptChip key={prompt} text={prompt} onSelect={(text) => open(text)} />
        ))}
      </Box>
    </Paper>
  );
};

export default DashboardContractSearchCard;
